import {useCurrentUser} from "~/hooks";
import {
    DashboardDefault,
    DashboardDesignManager,
    DashboardSales,
    DashboardSaleManager,
    DashboardSaleSupper,
    DashboardPersonnel,
    DashBoardTechnician,
    DashboardAccountingManager
} from "../Dashboard";
function Home() {

    const user = useCurrentUser();

    let DashboardName = DashboardDefault;

    if(user?.role?.key === 'sales' || user?.role?.key === 'salesLeader')
    {
        DashboardName = DashboardSales;
    }
    if(user?.role?.key === 'salesManager' || user?.role?.key === 'salesSenior')
    {
        DashboardName = DashboardSaleManager;
    }
    if(user?.role?.key === 'salesSupper')
    {
        DashboardName = DashboardSaleSupper;
    }
    if(user?.role?.key === 'personnel' || user?.role?.key === 'personnelManager')
    {
        DashboardName = DashboardPersonnel;
    }
    if(user?.role?.key === 'technician' || user?.role?.key === 'technicianLeader' || user?.role?.key === 'chiefTechnician')
    {
        DashboardName = DashBoardTechnician;
    }
    if(user?.role?.key === 'design' || user?.role?.key === 'designDeputy' || user?.role?.key === 'designManager')
    {
        DashboardName = DashboardDesignManager;
    }
    if(user?.role?.key === 'accountingManager')
    {
        DashboardName = DashboardAccountingManager;
    }
    
    return (
        <>
            <DashboardName user={user} />
        </>
    )
}

export default Home;